module.exports = __webpack_public_path__ + "img/not-verified.8ab8833b.svg";